import { Alert, AlertTitle, Button, Stack, Tooltip, Zoom } from '@mui/material'
import { useMutation } from 'urql'
import { useOrderContext } from '../contexts/OrderContextProvider'
import { graphql } from '../gql'
import { PurchaseOrderClosureReason, RfqStatus } from '../gql/graphql'

const closeAsPaidInFullMutation = graphql(/* GraphQL */ `
  mutation OrderActionsClosePurchaseOrder($poId: Int!, $closureReason: PurchaseOrderClosureReason) {
    ClosePurchaseOrder(id: $poId, closureReason: $closureReason) {
      id
    }
  }
`)

const reopenPurchaseOrderMutation = graphql(/* GraphQL */ `
  mutation OrderActionsReopenPurchaseOrder($poId: Int!) {
    ReopenPurchaseOrder(id: $poId) {
      id
    }
  }
`)

export const OrderActions = () => {
  const { rfq, openPaymentDialog } = useOrderContext()

  const [closeAsPaidInFullResult, closeAsPaidInFull] = useMutation(closeAsPaidInFullMutation)
  const [reopenPurchaseOrderResult, reopenPurchaseOrder] = useMutation(reopenPurchaseOrderMutation)

  const handleCloseAsPaidInFull = async () => {
    if (!rfq) return
    if (!rfq.quote?.purchaseOrder) return
    await closeAsPaidInFull({ poId: rfq.quote?.purchaseOrder.id, closureReason: PurchaseOrderClosureReason.PaidInFull })
  }

  const handleReopenPurchaseOrder = async () => {
    if (!rfq) return
    if (!rfq.quote?.purchaseOrder) return
    await reopenPurchaseOrder({ poId: rfq.quote?.purchaseOrder?.id })
  }

  if (!rfq) return null
  return (
    <>
      {closeAsPaidInFullResult.error && (
        <Alert severity="error">
          <AlertTitle>An Error Ocurred</AlertTitle>
          {closeAsPaidInFullResult.error.message}
        </Alert>
      )}
      {reopenPurchaseOrderResult.error && (
        <Alert severity="error">
          <AlertTitle>An Error Ocurred</AlertTitle>
          {reopenPurchaseOrderResult.error.message}
        </Alert>
      )}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        {rfq.status === RfqStatus.Quoted && (
          <Button variant="contained" color="secondary">
            Close as Lost
          </Button>
        )}
        {[RfqStatus.Purchased, RfqStatus.Paid].includes(rfq.status) && (
          <Button
            variant="contained"
            color="secondary"
            onClick={openPaymentDialog}
            disabled={closeAsPaidInFullResult.fetching}
          >
            Add Payment
          </Button>
        )}
        {rfq.status === RfqStatus.Paid && (
          <Tooltip
            title="Close the purchase order as paid in full. You can re-open it later if needed."
            arrow
            slots={{
              transition: Zoom,
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCloseAsPaidInFull}
              disabled={closeAsPaidInFullResult.fetching}
            >
              Close as Paid In Full
            </Button>
          </Tooltip>
        )}
        {rfq.status === RfqStatus.PaidInFull && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReopenPurchaseOrder}
            disabled={reopenPurchaseOrderResult.fetching}
          >
            Re-Open
          </Button>
        )}
      </Stack>
    </>
  )
}
